import { getTeamStandings } from "../../../api";

export const fetchTeamStandings = async ({
  provider,
  discipline,
  competitionIds = [],
  season,
  widgetConfigurationId = null,
  day = null,
  statType = 'general',
}) => {
  const { data } = await getTeamStandings({
    provider,
    discipline,
    competitionIds,
    season,
    widgetConfigurationId,
    day,
    statType,
  });

  return data;
};